import { render, staticRenderFns } from "./MainPanel.vue?vue&type=template&id=fbc36f94&scoped=true&"
import script from "./MainPanel.vue?vue&type=script&lang=js&"
export * from "./MainPanel.vue?vue&type=script&lang=js&"
import style0 from "./MainPanel.vue?vue&type=style&index=0&id=fbc36f94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbc36f94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/l-setting-for-configuration-tool/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbc36f94')) {
      api.createRecord('fbc36f94', component.options)
    } else {
      api.reload('fbc36f94', component.options)
    }
    module.hot.accept("./MainPanel.vue?vue&type=template&id=fbc36f94&scoped=true&", function () {
      api.rerender('fbc36f94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Layout/MainPanel.vue"
export default component.exports